'use client';

import { Brand } from '@spikemark/ui/shell/brand';
import { Button } from '@spikemark/ui/components/ui/button';
import { useRouter } from 'next/navigation';
export function ComingSoon() {
  const router = useRouter();
  const text = "Sorry, we're not quite ready for you, check back soon.";
  return <div className="w-full flex flex-col justify-center items-center space-y-4 p-4" data-sentry-component="ComingSoon" data-sentry-source-file="coming-soon.tsx">
      <Brand data-sentry-element="Brand" data-sentry-source-file="coming-soon.tsx" />
      <span className="text-center">{text}</span>
      <div className="flex space-x-3">
        <Button onClick={() => router.back()} data-sentry-element="Button" data-sentry-source-file="coming-soon.tsx">Back</Button>
        <Button onClick={() => router.push('/')} data-sentry-element="Button" data-sentry-source-file="coming-soon.tsx">Home</Button>
      </div>
    </div>;
}